<div
  class="category-article-order"
  fxLayout="column"
  fxLayoutGap="15px"
>
  <mat-card
    fxLayout="column"
    fxLayoutGap="15px"
  >
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      fxLayoutGap="15px"
    >
      <app-section-header
        title="Kolejność artykułów"
        description="Przeciągnij artykuły, aby ustawić kolejność wyświetlania w kategorii."
      ></app-section-header>

      <div
        fxLayout="row"
        fxLayoutGap="10px"
      >
        <button
          *ngIf="changed"
          mat-stroked-button
          type="button"
          (click)="reset()"
          [disabled]="saving"
        >
          <mat-icon>refresh</mat-icon>
          <span> Cofnij zmiany</span>
        </button>

        <button
          mat-raised-button
          color="primary"
          type="button"
          (click)="save()"
          [disabled]="!changed || saving"
        >
          <mat-icon>
            {{ saving ? 'hourglass_empty' : 'save' }}
          </mat-icon>

          <span>
            {{
              saving
                ? ' Zapisywanie...'
                : ' Zapisz kolejność'
            }}
          </span>
        </button>
      </div>
    </div>

    <div
      *ngIf="articles.length"
      class="category-article-order__list"
      cdkDropList
      [cdkDropListData]="articles"
      (cdkDropListDropped)="drop($event)"
    >
      <div
        *ngFor="
          let article of articles;
          let i = index;
          trackBy: trackByUuid
        "
        class="category-article-order__item"
        cdkDrag
        [cdkDragDisabled]="saving"
      >
        <div
          class="category-article-order__handle"
          cdkDragHandle
          matTooltip="Przeciągnij, aby zmienić pozycję"
        >
          <mat-icon>drag_indicator</mat-icon>
        </div>

        <div class="category-article-order__position">
          {{ i + 1 }}
        </div>

        <div class="category-article-order__content">
          <div class="category-article-order__name">
            {{ article.name }}
          </div>

          <div class="category-article-order__meta">
            <span *ngIf="article.publicationDate">
              {{
                article.publicationDate
                  | date:'yyyy-MM-dd'
              }}
            </span>

            <span *ngIf="!article.active">
              Nieaktywny
            </span>
          </div>
        </div>

        <div class="category-article-order__status">
          <mat-icon
            *ngIf="article.active"
            matTooltip="Aktywny"
          >
            visibility
          </mat-icon>

          <mat-icon
            *ngIf="!article.active"
            matTooltip="Nieaktywny"
          >
            visibility_off
          </mat-icon>
        </div>
      </div>
    </div>

    <div
      *ngIf="!articles.length"
      class="category-article-order__empty"
    >
      <mat-icon>article</mat-icon>

      <span>
        Brak artykułów przypisanych do tej kategorii.
      </span>
    </div>
  </mat-card>
</div>
